// for scroll and padding-right:
export const userAgent = navigator.userAgent.toLowerCase();
export const isIosDevice = /ipad|iphone|ipod|macintosh/.test(userAgent);
export const isMozillaMobile = userAgent.includes('mozilla') && userAgent.includes('android');
